export default __webpack_public_path__ + "static/media/ActiveCamera.21e3e7e8.svg";